import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { SMS_PATIENT_MESSAGES_KEY } from "@/services/sms";
/**
 * Patches a pushed `sms_status` event into any cached patient message list that
 * already contains the message, matched by message id. Only touches existing
 * caches, so it never fabricates history for an unopened patient.
 */
export function applySmsStatusEvent(queryClient, event) {
  if (!event || event.message_id == null) return;
  queryClient.setQueriesData([SMS_PATIENT_MESSAGES_KEY], function (messages) {
    if (!(messages !== null && messages !== void 0 && messages.some(function (message) {
      return message.id === event.message_id;
    }))) {
      return messages;
    }
    return messages.map(function (message) {
      var _event$failure_reason;
      return message.id === event.message_id ? _objectSpread(_objectSpread({}, message), {}, {
        status: event.status,
        status_label: event.status_label,
        failure_reason: (_event$failure_reason = event.failure_reason) !== null && _event$failure_reason !== void 0 ? _event$failure_reason : message.failure_reason
      }) : message;
    });
  });
}